export const ALL_PERMISSIONS = {
  PARAMETER_MGMT_VIEW: "parameterManagementView",
  PARAMETER_MGMT_ADD: "parameterManagementAdd",
  PARAMETER_MGMT_EDIT: "parameterManagementEdit",
  PARAMETER_MGMT_DELETE: "parameterManagementDelete",
  KANBAN_EDIT: "kanbanEdit",
  KANBAN_VIEW: "kanbanView",
  PROJECT_ADD: "projectAdd",
  PROJECT_EDIT: "projectEdit",
  PROJECT_DELETE: "projectDelete",
  PROJECT_VIEW: "projectView",
  USER_ADD: "userAdd",
  USER_EDIT: "userEdit",
  USER_DELETE: "userDelete",
  USER_VIEW: "userView",
  USER_IMPORT: "userImport",
  MODAL_HEALTH_REPORT_EXPORT: "modelHealthReportExport",
  MODAL_HEALTH_REPORT_VIEW: "modelHealthReportView",
  MODAL_HEALTH_REPORT_DELETE: "modelHealthReportDelete",
  MODAL_HEALTH_SETTINGS_VIEW: "modelHealthSettingsView",
  MODAL_HEALTH_SETTINGS_EDIT: "modelHealthSettingsEdit",
  MODAL_FILE_VIEW: "modelFileView",
  MODAL_FILE_EXPORT: "modelFileExport",
  PROJECT_TRACKING: "projectTracking",
  PROJECT_MANAGEMENT: "projectManagement",
  PRICING_DATABASE_VIEW: "pricingDatabaseView",
  PRICING_DATABASE_EDIT: "pricingDatabaseEdit",
  PRICING_DATABASE_DELETE: "pricingDatabaseDelete",
  MILESTONE_VIEW: "milestoneView",
  MILESTONE_ADD: "milestoneAdd",
  MILESTONE_EDIT: "milestoneEdit",
  MILESTONE_DELETE: "milestoneDelete",
  MILESTONE_IMPORT: "milestoneImport",
  PROJECT_EXPORT_SETTINGS_VIEW: "projectExportSettingsView",
  PROJECT_EXPORT_SETTINGS_EDIT: "projectExportSettingsEdit",
  PROJECT_EXPORT_SETTINGS_ADD: "projectExportSettingsAdd",
  // The Estimation app (Rust/WebAssembly at /estimation). NOT one of the
  // three below: those gate the older estimation features and a shared key
  // cannot be narrowed later.
  ESTIMATION: "estimation",
  // The Estimating Database pages (Database drawer section). Not
  // PRICING_DATABASE_VIEW: that one also gates the older Pricing Catalogs
  // page, so a shared key could not be granted apart.
  ESTIMATING_DATABASE: "estimatingDatabase",
  ESTIMATION_EXPORT: "estimationExport",
  ESTIMATION_SHARE: "estimationShare",
  ESTIMATION_VIEW: "estimationView",
  ROLE_ADD: "roleAdd",
  ROLE_EDIT: "roleEdit",
  ROLE_DELETE: "roleDelete",
  ADMIN_SECTION_ACCESS: "adminSectionAccess",
  REAL_TIME_ESTIMATE: "realTimeEstimate",
  SHARE_PROJECT_ADD: "shareProjectAdd",
  ASSIGN_PROJECT_ADD: "assignProjectAdd",
  ASSIGN_PROJECT_DELETE: "assignProjectDelete",
  THREE_D_MODAL_VIEW: "3dModelView",
  FILTER_VIEW: "filterView",
  FILTER_ADD: "filterAdd",
  FILTER_EDIT: "filterEdit",
  FILTER_DELETE: "filterDelete",
  ASSET_MANAGEMENT_VIEW: "assetManagementView",
  ASSET_MANAGEMENT_ADD: "assetManagementAdd",
  ASSET_MANAGEMENT_EDIT: "assetManagementEdit",
  ASSET_MANAGEMENT_DELETE: "assetManagementDelete",
  DOC_CONTROL_VIEW: "docControlView",
  DOC_CONTROL_ADD: "docControlAdd",
  DOC_CONTROL_DELETE: "docControlDelete",
  DOC_CONTROL_EDIT: "docControlEdit",
  ISSUE_VIEW: "issueView",
  ISSUE_CREATE: "issueCreate",
  ISSUE_EDIT: "issueEdit",
  ISSUE_DELETE: "issueDelete",
  ISSUE_SHARE: "issueShare",
  ANALYTICS_VIEW: "analyticsView",
  ANALYTICS_EXPORT: "analyticsExport",
  DISCIPLINE_VIEW: "disciplineView",
  DISCIPLINE_ADD: "disciplineAdd",
  DISCIPLINE_EDIT: "disciplineEdit",
  DISCIPLINE_DELETE: "disciplineDelete",
  REVISION_VIEW: "revisionView",
  REVISION_ADD: "revisionAdd",
  REVISION_EDIT: "revisionEdit",
  REVISION_DELETE: "revisionDelete",
  ENGINEERING_TRACKING_VIEW: "engineeringTrackingView",
  ENGINEERING_TRACKING_EDIT: "engineeringTrackingEdit",
  ENGINEERING_TRACKING_ADD: "engineeringTrackingAdd",
  ENGINEERING_TRACKING_DELETE: "engineeringTrackingDelete",
  TAKEOFF_VIEW: 'takeoffView',
  TAKEOFF_EDIT: 'takeoffEdit',
  TAKEOFF_ADD: 'takeoffAdd',
  TAKEOFF_DELETE: 'takeoffDelete',
  TAKEOFF_EXPORT: 'takeoffExport',
  AFFILIATIONS_VIEW: 'affiliationView',
  AFFILIATIONS_ADD: 'affiliationAdd',
  AFFILIATIONS_EDIT: 'affiliationEdit',

  // ─── Roadmap additions ─────────────────────────────────────────────
  // Keys must mirror back/utils/permissions.js PERMS and the values
  // listed in back/bin/config.js Packages so the existing
  // FinalPermissions intersection (allPerms ∩ companyPerms) carries
  // them through unchanged.
  COMMIT_VIEW: 'commitView',
  COMMIT_PUSH: 'commitPush',
  TIMELINE_VIEW: 'timelineView',
  ESTIMATE_PUSH: 'estimatePush',
  ANALYTICS_CONTRIBUTORS_VIEW: 'analyticsContributorsView',
  TEAM_INSIGHTS_VIEW: 'teamInsightsView',
  SUGGESTIONS_RUN: 'suggestionsRun',
  SUGGESTIONS_DISMISS: 'suggestionsDismiss',
  ISSUE_PROPOSE_RESOLUTION: 'issueProposeResolution',
  ISSUE_APPROVE_RESOLUTION: 'issueApproveResolution',
  ISSUE_RESOLVE_DIRECT: 'issueResolveDirect',
  REVISION_REVIEW: 'revisionReview',
  FRAGMENT_BROWSER_VIEW: 'fragmentBrowserView',
  FRAGMENT_BROWSER_DELETE: 'fragmentBrowserDelete',
  ISSUE_CLOSE: 'issueClose',
  REVIEW_CENTER_VIEW: 'reviewCenterView',
  REVIEW_CENTER_APPROVE: 'reviewCenterApprove',
  // Coordination CRUD split (2026-08-17). participantManage is the legacy
  // umbrella (server expands it to the four participant keys).
  PARTICIPANT_VIEW: 'participantView',
  PARTICIPANT_ADD: 'participantAdd',
  PARTICIPANT_EDIT: 'participantEdit',
  PARTICIPANT_DELETE: 'participantDelete',
  PARTICIPANT_MANAGE: 'participantManage',
  // Reports & notifications for the projects a member runs (see
  // back/utils/permissions.js NOTIFICATIONS_MANAGE).
  NOTIFICATIONS_MANAGE: 'notificationsManage',
  GANTT_VIEW: 'ganttView',
  GANTT_ADD: 'ganttAdd',
  GANTT_EDIT: 'ganttEdit',
  GANTT_DELETE: 'ganttDelete',
  GANTT_PROGRESS_REPORT: 'ganttProgressReport',
  CHECKLIST_VIEW: 'checklistView',
  CHECKLIST_ADD: 'checklistAdd',
  CHECKLIST_EDIT: 'checklistEdit',
  CHECKLIST_DELETE: 'checklistDelete',
  MINUTES_VIEW: 'minutesView',
  MINUTES_ADD: 'minutesAdd',
  MINUTES_EDIT: 'minutesEdit',
  // Every coordination tab, CRUD (2026-10-14) - mirrors back/utils/permissions.
  MINUTES_DELETE: 'minutesDelete',
  SHOP_DRAWING_VIEW: 'shopDrawingView',
  SHOP_DRAWING_ADD: 'shopDrawingAdd',
  SHOP_DRAWING_EDIT: 'shopDrawingEdit',
  SHOP_DRAWING_DELETE: 'shopDrawingDelete',
  TRACKING_VIEW: 'constructionTrackingView',
  TRACKING_ADD: 'constructionTrackingAdd',
  TRACKING_EDIT: 'constructionTrackingEdit',
  TRACKING_DELETE: 'constructionTrackingDelete',
  AREAS_VIEW: 'levelsAreasView',
  AREAS_ADD: 'levelsAreasAdd',
  AREAS_EDIT: 'levelsAreasEdit',
  AREAS_DELETE: 'levelsAreasDelete',
  TECH_DOCS_VIEW: 'technicalDocsView',
  TECH_DOCS_ADD: 'technicalDocsAdd',
  TECH_DOCS_EDIT: 'technicalDocsEdit',
  TECH_DOCS_DELETE: 'technicalDocsDelete',
  DOC_IMPORT_VIEW: 'documentImportView',
  DOC_IMPORT_ADD: 'documentImportAdd',
  DOC_IMPORT_EDIT: 'documentImportEdit',
  DOC_IMPORT_DELETE: 'documentImportDelete',
  SHEET_SEARCH_VIEW: 'sheetSearchView',
  // RFI Generator (2026-10-20): see / draft + build / approve / the
  // company's cover template.
  RFI_VIEW: 'rfiView',
  RFI_CREATE: 'rfiCreate',
  RFI_APPROVE: 'rfiApprove',
  RFI_TEMPLATE_MANAGE: 'rfiTemplateManage',
  CONTRACTOR_RATES_VIEW: 'contractorRatesView',
  CONTRACTOR_RATES_ADD: 'contractorRatesAdd',
  CONTRACTOR_RATES_EDIT: 'contractorRatesEdit',
  CONTRACTOR_RATES_DELETE: 'contractorRatesDelete',
};
